import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Notebox(props) {
  return (
    <div className="p-100 pb-0">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="boxes_item text-center">
              <Row>
                <Col xs={12} md={10} lg={8} xl={8} xxl={8} className="m-auto">
                  <h2>
                    How is ERP Implementation Influencing Business Outcomes?
                  </h2>
                  <p>
                    Around 80% of global businesses use ERP solutions to
                    streamline their business processes, improve organizational
                    productivity, and advance order fulfillment and accuracy by
                    considerable margins.
                  </p>
                  <p>
                    Being a leading ERP development company, we assist you in
                    making your business operations scalable, innovative, and
                    modernized.
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Notebox;
